import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Image } from "antd";
import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import App from "./App";
import elementalSvg from "./assets/image/elemental 'e'.svg";
import "./index.css";
import { sendErrorNotification } from "./services/api-server/base";

const queryClient = new QueryClient();

// Disable console.log in production
if (import.meta.env.VITE_LOG !== "true") {
	console.log = () => {};
}

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);
const handleErrorFallback = (props: any) => {
	return (
		<div style={{ height: "100vh", width: "100vw" }}>
			<div className="no-access-container">
				<div className="hexlock-container">
					<div className="noaccess-icon">
						<Image
							preview={false}
							width={"185px"}
							className="home-logo no-visual-search"
							src={elementalSvg}
							alt="Logo"
						/>
					</div>
				</div>
				<span
					style={{ fontSize: "20px", lineHeight: "30px", textAlign: "center" }}
				>
					An unexpected error has occurred. Please try again later.
					<br />
					<a href="" style={{ textDecoration: "none" }}>
						Reload Page
					</a>
				</span>
			</div>
		</div>
	);
};

const logError = (error: any, info: any) => {
	if (import.meta.env.VITE_NODE_ENV === "production") {
		error.location = window.location.pathname;
		error.level = "root";
		let JSONerror = JSON.stringify(error, Object.getOwnPropertyNames(error));
		sendErrorNotification(JSONerror);
	}
};

root.render(
	<QueryClientProvider client={queryClient}>
		<ErrorBoundary fallbackRender={handleErrorFallback} onError={logError}>
			<App />
		</ErrorBoundary>
		{/* {import.meta.env.VITE_NODE_ENV !== "production" && (
			<ReactQueryDevtools initialIsOpen={false} />
		)} */}
	</QueryClientProvider>
);
